import PropTypes from "prop-types";
import style from "./styles";
import NewTabSVG from "../../../../../../assets/premier-landing-page/img/svg/icon_new_tab.svg";

const FAQItem = ({ question, link }) => (
  <li className={style.FAQItem}>
    <a href={link} target="_blank" rel="noreferrer" title="Link opens new tab">
      <span className={style.FAQQuestion}>{question}</span>
      <span className={style.FAQIcon}>
        <NewTabSVG />
      </span>
    </a>
  </li>
);

FAQItem.propTypes = {
  question: PropTypes.string,
  link: PropTypes.string,
};

export default FAQItem;
